import { render, staticRenderFns } from "./AppletList.vue?vue&type=template&id=23a3caba&scoped=true&"
import script from "./AppletList.vue?vue&type=script&lang=js&"
export * from "./AppletList.vue?vue&type=script&lang=js&"
import style0 from "./AppletList.vue?vue&type=style&index=0&id=23a3caba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a3caba",
  null
  
)

export default component.exports